import type { DefaultToastOptions } from "react-hot-toast";

export const toasterStyles: DefaultToastOptions = {
  success: {
    duration: 4000,
    position: "top-right",
    style: {
      background: "#0eaa18",
      color: "#ffffff",
    },
  },
  error: {
    duration: 4000,
    position: "top-right",
    style: {
      background: "#e02424",
      color: "#ffffff",
    },
  },
};
